{
  "comment": "Kell's tier nudges and hint ladder, the Mutual archivist, the claim recipients, generic refusals (spec §2.3, §3.1, §11; S9 owns). Node shape: src/story/schemas.ts commsNodeSchema (a speaker, 1–3 lines, 1–4 replies; \"Show [log]\" replies; a reply without next ends the conversation). Node ids are unique across every comms file. Ids S7/S14 read: kell.nudge.<tier 1-4>, kell.hint.<tier 1-4>.<rung 1-2>, kell.safety_net, archivist.safety_net, claim.<tier>.<speaker>.holds|fails (src/story/comms.ts builds them). speakers: display names (placeholders until the naming pass, spec §15 item 7), faction tint, placeholder portrait id. contacts: the §3.1 table, primary option first then fallbacks in order (src/story/contacts.ts contactFor); hostileStanding −50 and wantedLevel 1 mirror src/strategic/law/docking.ts; minStanding 30 on the legal archive route is the spec placeholder.",
  "speakers": {
    "kell": { "name": "Tomas Kell", "faction": "holdfast", "portrait": "portrait.kell" },
    "reyes": { "name": "Ama Reyes", "faction": "guardian", "portrait": "portrait.reyes" },
    "okafor": { "name": "Dr Idris Okafor", "portrait": "portrait.okafor" },
    "duarte": { "name": "Ines Duarte", "faction": "authority", "portrait": "portrait.duarte" },
    "hale": { "name": "Commissioner Hale", "faction": "authority", "portrait": "portrait.hale" },
    "voss": { "name": "Maren Voss", "faction": "tethys", "portrait": "portrait.voss" },
    "mutualArchivist": { "name": "Spacers' Mutual Archive", "faction": "mutual", "portrait": "portrait.mutual_archivist" },
    "mutualScrapyard": { "name": "Mutual Scrapyard", "faction": "mutual", "portrait": "portrait.mutual_scrapyard" },
    "assetRecovery": { "name": "Tethys Asset Recovery", "faction": "tethys", "portrait": "portrait.asset_recovery" },
    "meridianCounsel": { "name": "Meridian Counsel", "faction": "meridian", "portrait": "portrait.meridian_counsel" },
    "meridianDesk": { "name": "Meridian Desk", "faction": "meridian", "portrait": "portrait.meridian_desk" },
    "charterPatrol": { "name": "Charter Patrol", "faction": "authority", "portrait": "portrait.charter_patrol" },
    "recordsDesk": { "name": "Charter Hub Records", "faction": "authority", "portrait": "portrait.records_desk" },
    "stationControl": { "name": "Station Control", "portrait": "portrait.station_control" },
    "mutualRelayCrew": { "name": "Mutual Relay Crew", "faction": "mutual", "portrait": "portrait.mutual_relay_crew" }
  },
  "contacts": {
    "hostileStanding": -50,
    "wantedLevel": 1,
    "retaliationFaction": "tethys",
    "refusalNodes": {
      "hostile": "refusal.hostile",
      "wanted": "refusal.wanted",
      "retaliation": "refusal.retaliation",
      "standing": "refusal.standing"
    },
    "interactions": {
      "claim2": [
        { "id": "scrapyard-dock", "speaker": "mutualScrapyard", "channel": "dock", "faction": "mutual" },
        { "id": "scrapyard-comms", "speaker": "mutualScrapyard", "channel": "comms" }
      ],
      "claim3": [
        { "id": "kell-comms", "speaker": "kell", "channel": "comms", "faction": "holdfast" },
        { "id": "archivist-comms", "speaker": "mutualArchivist", "channel": "comms" }
      ],
      "claim4": [
        { "id": "okafor-comms", "speaker": "okafor", "channel": "comms", "okaforIn": ["hideout", "aboard", "safe"] },
        { "id": "kell-comms", "speaker": "kell", "channel": "comms", "faction": "holdfast" },
        { "id": "archivist-comms", "speaker": "mutualArchivist", "channel": "comms" }
      ],
      "claim5": [
        { "id": "records-dock", "speaker": "recordsDesk", "channel": "dock", "faction": "authority" },
        { "id": "duarte-desk-line", "speaker": "duarte", "channel": "comms", "flagsNone": ["duarte_exposed"] },
        { "id": "archivist-comms", "speaker": "mutualArchivist", "channel": "comms" }
      ],
      "safetyNet": [
        { "id": "kell-comms", "speaker": "kell", "channel": "comms", "faction": "holdfast", "node": "kell.safety_net" },
        { "id": "archivist-comms", "speaker": "mutualArchivist", "channel": "comms", "node": "archivist.safety_net" }
      ],
      "m1Decode": [
        { "id": "scrapyard-dock", "speaker": "mutualScrapyard", "channel": "dock", "faction": "mutual" },
        { "id": "mutual-station-dock", "speaker": "mutualScrapyard", "channel": "dock", "faction": "mutual" },
        { "id": "holdfast-workshop-dock", "speaker": "kell", "channel": "dock", "faction": "holdfast" }
      ],
      "m2Offer": [
        { "id": "kell-comms", "speaker": "kell", "channel": "comms", "faction": "holdfast" }
      ],
      "m2Package": [
        { "id": "guardian-base-dock", "speaker": "reyes", "channel": "dock", "faction": "guardian", "lawless": true },
        { "id": "kell-comms", "speaker": "kell", "channel": "comms", "faction": "holdfast" }
      ],
      "m3Okafor": [
        { "id": "hideout-dock", "speaker": "okafor", "channel": "dock" }
      ],
      "m3Rescue": [
        { "id": "tethys-station-dock", "speaker": "okafor", "channel": "dock", "faction": "tethys" },
        { "id": "prisoner-transport", "speaker": "okafor", "channel": "ship" }
      ],
      "m4Duarte": [
        { "id": "charter-hub-dock", "speaker": "duarte", "channel": "dock", "faction": "authority" },
        { "id": "duarte-comms", "speaker": "duarte", "channel": "comms" }
      ],
      "m4Archive": [
        { "id": "legal-route-dock", "speaker": "recordsDesk", "channel": "dock", "faction": "authority", "minStanding": 30 },
        { "id": "back-route-shuttle", "speaker": "mutualRelayCrew", "channel": "ship" }
      ],
      "haleCall": [
        { "id": "hale-comms", "speaker": "hale", "channel": "comms" }
      ],
      "vossContact": [
        { "id": "voss-comms", "speaker": "voss", "channel": "comms" }
      ],
      "rollCall": [
        { "id": "kell-comms", "speaker": "kell", "channel": "comms" }
      ],
      "exposeHandIn": [
        { "id": "hearing-dock", "speaker": "duarte", "channel": "dock", "faction": "authority" },
        { "id": "kell-wire-leak", "speaker": "kell", "channel": "comms", "faction": "holdfast" },
        { "id": "duarte-comms", "speaker": "duarte", "channel": "comms", "flagsNone": ["duarte_exposed"] },
        { "id": "archivist-bulletin", "speaker": "mutualArchivist", "channel": "comms" }
      ],
      "blackmail": [
        { "id": "megacorp-hq-dock", "speaker": "voss", "channel": "dock", "faction": "tethys" },
        { "id": "mutual-neutral-dock", "speaker": "voss", "channel": "dock", "faction": "mutual" },
        { "id": "voss-yacht", "speaker": "voss", "channel": "ship" }
      ],
      "guardians": [
        { "id": "reyes-comms", "speaker": "reyes", "channel": "comms", "reyesNotIn": ["hostile", "dead"] },
        { "id": "kell-comms", "speaker": "kell", "channel": "comms" }
      ],
      "sell": [
        { "id": "meridian-station-dock", "speaker": "meridianCounsel", "channel": "dock", "faction": "meridian" },
        { "id": "meridian-courier", "speaker": "meridianCounsel", "channel": "ship" }
      ],
      "registration": [
        { "id": "registry-desk-dock", "speaker": "duarte", "channel": "dock", "faction": "authority", "flagsNone": ["duarte_exposed"] },
        { "id": "duarte-comms-filing", "speaker": "duarte", "channel": "comms", "flagsNone": ["duarte_exposed"] },
        { "id": "archivist-filing", "speaker": "mutualArchivist", "channel": "comms", "node": "archivist.registration" }
      ]
    }
  },
  "nodes": [
    {
      "id": "kell.nudge.1",
      "speaker": "kell",
      "lines": [
        "Kell, Holdfast. You fly past the Harrow every run.",
        "There's a convoy core still sitting in that field. Nobody pulls it. Pull it."
      ],
      "replies": [
        { "id": "why", "text": "Why does it matter to you?", "next": "kell.nudge.1.why" },
        { "id": "show", "text": "Show him what you've already pulled.", "show": { "thread": "evacuation" }, "next": "kell.nudge.1.show" },
        { "id": "noted", "text": "Noted." }
      ]
    },
    {
      "id": "kell.nudge.1.why",
      "speaker": "kell",
      "lines": ["My grandmother's ship was in that field once. Read the core before you sell it."],
      "replies": [
        { "id": "ok", "text": "Fine." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.nudge.1.show",
      "speaker": "kell",
      "lines": [
        "Then you've seen the second column.",
        "I'm not going to tell you what it says. You tell me."
      ],
      "replies": [
        { "id": "ok", "text": "I'll read it again." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.nudge.2",
      "speaker": "kell",
      "lines": [
        "Kell. The Mutual says your question held up.",
        "There are people at the Harrow who've written the gate down every day for fifty years. Ask yourself what they're counting."
      ],
      "replies": [
        { "id": "who", "text": "Who are they?", "next": "kell.nudge.2.who" },
        { "id": "noted", "text": "Noted." }
      ]
    },
    {
      "id": "kell.nudge.2.who",
      "speaker": "kell",
      "lines": ["Families who stayed. They don't take visitors. They read wrecks, though."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.nudge.3",
      "speaker": "kell",
      "lines": [
        "Somebody measured this before you did. Tethys had a research group at Carrow, once.",
        "They broke it up. Find out where the people went."
      ],
      "replies": [
        { "id": "ok", "text": "I'll look." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.nudge.4",
      "speaker": "kell",
      "lines": [
        "The Authority closed its file on the Collapse inside a year.",
        "Quick work. Somebody at the registry knows which shelf it went on."
      ],
      "replies": [
        { "id": "ok", "text": "I'll ask." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.1.1",
      "speaker": "kell",
      "lines": ["Still on the queue? Ask the plain question: who went through first, and on whose say-so?"],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.1.2",
      "speaker": "kell",
      "lines": [
        "Convoy wrecks near the Harrow still carry cores.",
        "Read the authorisation column. The names won't help you."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.2.1",
      "speaker": "kell",
      "lines": ["The gate holds, then lets go. What else changes on the days it holds?"],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.2.2",
      "speaker": "kell",
      "lines": [
        "Carrow posts its shift roster. It's public.",
        "Put it next to the hold times and look at it for a while."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.3.1",
      "speaker": "kell",
      "lines": ["Somebody wrote this up once. Who did they send it to?"],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.3.2",
      "speaker": "kell",
      "lines": [
        "Paper moves on routing slips. Every slip has a desk at the end of it.",
        "Find the desk that didn't pass it on."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.4.1",
      "speaker": "kell",
      "lines": ["Who signed off on the official story, and what did they get for it?"],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.hint.4.2",
      "speaker": "kell",
      "lines": [
        "Commission minutes get sealed, not burned.",
        "Sealed files get reviewed every ten years. Somebody initials the review."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "kell.safety_net",
      "speaker": "kell",
      "lines": [
        "That question's been on your board a while. Send me what you've got.",
        "I'll have a look. It costs credits, not favours."
      ],
      "replies": [
        { "id": "pay", "text": "Send it. I'll pay." },
        { "id": "decline", "text": "I'll work it out myself." }
      ]
    },
    {
      "id": "archivist.safety_net",
      "speaker": "mutualArchivist",
      "lines": [
        "Spacers' Mutual Archive. Your question has been sitting in our queue.",
        "Send the file. We check it against what we hold. Fee in advance."
      ],
      "replies": [
        { "id": "pay", "text": "Send it. I'll pay." },
        { "id": "decline", "text": "Not yet." }
      ]
    },
    {
      "id": "archivist.corroborate.order",
      "speaker": "mutualArchivist",
      "lines": [
        "We hold the Mutual's copies of the old hull insurance claims.",
        "We can pull the ones you name. Fee in advance, one pull at a time."
      ],
      "replies": [
        { "id": "pull", "text": "Pull them." },
        { "id": "decline", "text": "Not now." }
      ]
    },
    {
      "id": "archivist.registry_copy",
      "speaker": "mutualArchivist",
      "lines": [
        "The registry keeps a copy of every sealed index. So do we.",
        "A certified extract costs the same as anywhere. Nobody here reports the request."
      ],
      "replies": [
        { "id": "pull", "text": "Pull the extract." },
        { "id": "decline", "text": "Not now." }
      ]
    },
    {
      "id": "archivist.registration",
      "speaker": "mutualArchivist",
      "lines": [
        "You want a restart lodged with the registry. We can file it under our seal.",
        "Fee in advance. The registry takes its time either way."
      ],
      "replies": [
        { "id": "file", "text": "File it." },
        { "id": "decline", "text": "Not now." }
      ]
    },
    {
      "id": "claim.2.mutual_scrapyard.holds",
      "speaker": "mutualScrapyard",
      "lines": [
        "Checked it against the board, authorisation column and all. It matches.",
        "No fee on this one."
      ],
      "replies": [
        { "id": "ok", "text": "Thanks." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.2.mutual_scrapyard.fails",
      "speaker": "mutualScrapyard",
      "lines": ["This doesn't hold up.", "Read something else and send it again."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.3.kell.holds",
      "speaker": "kell",
      "lines": ["Yes. That's what the Watch has been writing down.", "Come and see me."],
      "replies": [
        { "id": "ok", "text": "On my way." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.3.kell.fails",
      "speaker": "kell",
      "lines": ["This doesn't hold up.", "Go and look again."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.3.mutual_archivist.holds",
      "speaker": "mutualArchivist",
      "lines": ["Nothing we hold contradicts it.", "The Holdfast keep a longer series than we do."],
      "replies": [
        { "id": "ok", "text": "Thanks." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.3.mutual_archivist.fails",
      "speaker": "mutualArchivist",
      "lines": ["This doesn't hold up.", "The fee is not refundable."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.4.okafor.holds",
      "speaker": "okafor",
      "lines": [
        "Yes. That's the route it took.",
        "I knew where I sent it. I never let myself find out where it stopped."
      ],
      "replies": [
        { "id": "ok", "text": "Now you know." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.4.okafor.fails",
      "speaker": "okafor",
      "lines": ["This doesn't hold up.", "Check your sources. Then check them against each other."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.4.kell.holds",
      "speaker": "kell",
      "lines": ["That's the desk.", "Don't say it on an open channel again."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.4.kell.fails",
      "speaker": "kell",
      "lines": ["This doesn't hold up."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.4.mutual_archivist.holds",
      "speaker": "mutualArchivist",
      "lines": ["The routing marks agree with you.", "We've added the match to our index."],
      "replies": [
        { "id": "ok", "text": "Thanks." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.4.mutual_archivist.fails",
      "speaker": "mutualArchivist",
      "lines": ["This doesn't hold up.", "The fee is not refundable."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.5.records_desk.holds",
      "speaker": "recordsDesk",
      "lines": [
        "Request matched to a sealed minute. The index signatures agree with your filing.",
        "The minute itself remains sealed."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.5.records_desk.fails",
      "speaker": "recordsDesk",
      "lines": ["This doesn't hold up.", "Request closed. You may file again."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.5.duarte.holds",
      "speaker": "duarte",
      "lines": [
        "That's the minute.",
        "That's his initial on every retention stamp. I've seen it on my own desk for twelve years."
      ],
      "replies": [
        { "id": "ok", "text": "Thank you." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.5.duarte.fails",
      "speaker": "duarte",
      "lines": ["This doesn't hold up.", "I can't file it like that. Send it again when you have more."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.5.mutual_archivist.holds",
      "speaker": "mutualArchivist",
      "lines": ["Our copy of the index agrees with you, signatures and all."],
      "replies": [
        { "id": "ok", "text": "Thanks." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "claim.5.mutual_archivist.fails",
      "speaker": "mutualArchivist",
      "lines": ["This doesn't hold up.", "The fee is not refundable."],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "refusal.hostile",
      "speaker": "stationControl",
      "lines": [
        "Docking refused. Your standing with this station's owner doesn't clear.",
        "Your contact has been told to reach you on the channel."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "refusal.wanted",
      "speaker": "stationControl",
      "lines": [
        "Docking refused. You're carrying a warrant in this jurisdiction.",
        "Your contact has been told to reach you on the channel."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "refusal.retaliation",
      "speaker": "stationControl",
      "lines": [
        "Docking refused by order of the operator. No reason given.",
        "Your contact has been told to reach you on the channel."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "refusal.standing",
      "speaker": "stationControl",
      "lines": [
        "Access refused. Your standing doesn't meet the desk's requirement.",
        "There are other ways in. Not through this desk."
      ],
      "replies": [
        { "id": "ok", "text": "Understood." },
        { "id": "close", "text": "(close the channel)" }
      ]
    }
  ]
}
